module.exports = __webpack_public_path__ + "static/media/goddiva-main.175ff268.png";